module.exports = __webpack_public_path__ + "bg-img.091afd5bb435dd8c7f85.png";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/img/bg-img.png
// module id = ../../../../../src/assets/img/bg-img.png
// module chunks = main